/**
 * True when Back should call prevPage inside this form rather than leaving it.
 * Any page after the first has a previous page, even when branching history was
 * not recorded (that count is 0 for linear forms). On the first page, Back stays
 * in the form only when branching history has an earlier page.
 */
export function hasPreviousFormPage(visitedPageCount: number | null | undefined, pageIndex: number): boolean {
    if (pageIndex > 1) return true;
    return (visitedPageCount ?? 0) > 1;
}
